"use client";

import { c as _c } from "react/compiler-runtime";
import { Search, X } from "lucide-react";
import { useRef } from "react";
interface SearchProps {
  search: string;
  setSearch: React.Dispatch<React.SetStateAction<string>>;
  isSearchOpen: boolean;
  setIsSearchOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setVisibleItems: React.Dispatch<React.SetStateAction<number>>;
  PAGE_SIZE: number;
}
export default function InputSearch(t0) {
  const $ = _c(32);
  const {
    search,
    setSearch,
    isSearchOpen,
    setIsSearchOpen,
    setVisibleItems,
    PAGE_SIZE
  } = t0;
  const searchInputRef = useRef(null);
  const t1 = isSearchOpen ? "w-full xl:w-64 2xl:w-80 border-gray-300 rounded-xl max-h-12 mt-2 xl:my-auto" : "w-16 border-transparent";
  let t2;
  if ($[0] !== t1) {
    t2 = ["flex items-center overflow-hidden transition-all duration-500 ease-out border", t1];
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = t2.join(" ");
  const t4 = isSearchOpen ? "Fechar busca" : "Abrir busca";
  let t5;
  if ($[2] !== isSearchOpen || $[3] !== search || $[4] !== setIsSearchOpen) {
    t5 = () => {
      if (isSearchOpen && !search) {
        setIsSearchOpen(false);
        return;
      }
      setIsSearchOpen(true);
    };
    $[2] = isSearchOpen;
    $[3] = search;
    $[4] = setIsSearchOpen;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Search className="size-5" />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t4 || $[8] !== t5) {
    t7 = <button type="button" aria-label={t4} className="flex h-16 w-16 shrink-0 items-center justify-center text-gray-500 cursor-pointer transition hover:text-white" onClick={t5}>{t6}</button>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = isSearchOpen ? "opacity-100" : "pointer-events-none opacity-0";
  let t9;
  if ($[10] !== t8) {
    t9 = ["flex min-w-0 items-center transition-opacity duration-200", t8];
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const t10 = t9.join(" ");
  let t11;
  if ($[12] !== PAGE_SIZE || $[13] !== setSearch || $[14] !== setVisibleItems) {
    t11 = event => {
      setSearch(event.target.value);
      setVisibleItems(PAGE_SIZE);
    };
    $[12] = PAGE_SIZE;
    $[13] = setSearch;
    $[14] = setVisibleItems;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== search || $[17] !== t11) {
    t12 = <input ref={searchInputRef} value={search} onChange={t11} placeholder="Buscar post" className="h-16 w-full min-w-0 bg-transparent pr-4 text-base text-white outline-none placeholder:text-gray-100/70" />;
    $[16] = search;
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== PAGE_SIZE || $[20] !== search || $[21] !== setSearch || $[22] !== setVisibleItems) {
    t13 = search ? <button type="button" aria-label="Limpar busca" className="flex h-16 w-12 shrink-0 items-center justify-center text-gray-100/70 transition hover:text-white" onClick={() => {
      setSearch("");
      setVisibleItems(PAGE_SIZE);
      searchInputRef.current?.focus();
    }}><X className="size-4" /></button> : null;
    $[19] = PAGE_SIZE;
    $[20] = search;
    $[21] = setSearch;
    $[22] = setVisibleItems;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t10 || $[25] !== t12 || $[26] !== t13) {
    t14 = <div className={t10}>{t12}{t13}</div>;
    $[24] = t10;
    $[25] = t12;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t14 || $[29] !== t3 || $[30] !== t7) {
    t15 = <div className="flex xl:ml-6 max-md:mt-6"><div className={t3}>{t7}{t14}</div></div>;
    $[28] = t14;
    $[29] = t3;
    $[30] = t7;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  return t15;
}